import request from "@/utils/request"

// 共享记录查询
export function query(data){
  return request({
    url:'/db/assets-borrow-record/query',
    method:'post',
    data
  })
}

// 共享记录一键导出
export function reportExport(data){
  return request({
    url:'/db/assets-borrow-record/borrow-record-report-export',
    method:'post',
    data
  })
}